import {PaymentListOrderBy} from '../constant';
import {PaymentInfo} from '../types';
import PaymentListTableComponent from './PaymentComponent';

interface PaymentListTableProps {
  isLoading: boolean;
  isError: boolean;
  message: string;
  payments: PaymentInfo[];
  sortActiveColumn?: PaymentListOrderBy;
  sortDirection?: boolean;
  status?: string;
  setSortActiveColumn: (value?: PaymentListOrderBy) => void;
  setSortDirection: React.Dispatch<React.SetStateAction<boolean>>;
  setStatus?: (value: string) => void;
  onSort?: (column: PaymentListOrderBy) => void;
}

function PaymentListTable(props: PaymentListTableProps) {
  const {
    isLoading,
    isError,
    message,
    payments,
    sortActiveColumn,
    sortDirection,
    status,
    setSortActiveColumn,
    setSortDirection,
    setStatus,
    onSort,
  } = props;

  return (
    <PaymentListTableComponent
      isLoading={isLoading}
      isError={isError}
      message={message}
      payments={payments}
      sortActiveColumn={sortActiveColumn}
      sortDirection={sortDirection}
      status={status}
      setSortActiveColumn={setSortActiveColumn}
      setSortDirection={setSortDirection}
      setStatus={setStatus}
      onSort={onSort}
    />
  );
}

export default PaymentListTable;
